export default {
  install(Vue) {
    //날짜 문자열 변경 ('YYYY-MM-DD')
    Vue.config.globalProperties.$dateToString = function (date) {
      let yyyy = date.getFullYear();
      let mm = date.getMonth() + 1;
      let dd = date.getDate();

      mm = mm < 10 ? '0' + mm : mm.toString();
      dd = dd < 10 ? '0' + dd : dd.toString();

      return yyyy + '-' + mm + '-' + dd;
    }

    //날짜 일자 더하기
    Vue.config.globalProperties.$addDays = function (date, days) {

      const clone = new Date(date);

      clone.setDate(clone.getDate() + days);

      let yyyy = clone.getFullYear();
      let mm = clone.getMonth() + 1;
      let dd = clone.getDate();

      mm = mm < 10 ? '0' + mm : mm.toString();
      dd = dd < 10 ? '0' + dd : dd.toString();

      return yyyy + '-' + mm + '-' + dd;
    }

    //전월 날짜 구하기
    Vue.config.globalProperties.$getLastMonthRang = function () {
      let today = new Date();
      let firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      let lastDay = new Date(firstDayOfMonth.setDate(firstDayOfMonth.getDate() - 1));
      let startDay = new Date(lastDay.getFullYear(), lastDay.getMonth(), 1);

      return [startDay, lastDay];
    }

    //당월 날짜 구하기
    Vue.config.globalProperties.$getNowMonthRang = function () {
      let today = new Date();
      let startDay = new Date(today.getFullYear(), today.getMonth(), 1);

      return [startDay, today];
    }

    //전주 날짜 구하기
    Vue.config.globalProperties.$getLastWeekRang = function () {

      let now = new Date();
      let nowDayOfWeek = now.getDay();
      let nowDay = now.getDate();
      let nowMonth = now.getMonth();
      let nowYear = now.getFullYear();

      var lastweekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek - 7);
      var lastweekEndDate = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek - 7));

      return [lastweekStartDate, lastweekEndDate];
    }

    //전일 날짜 구하기
    Vue.config.globalProperties.$getYesterDayRang = function () {

      let now = new Date();
      let yesterDay = new Date(now.setDate(now.getDate() - 1));
      return [yesterDay, yesterDay];
    }

    //금주 날짜 구하기
    Vue.config.globalProperties.$getNowWeekRang = function () {

      let now = new Date();
      let nowDayOfWeek = now.getDay();
      let nowDay = now.getDate();
      let nowMonth = now.getMonth();
      let nowYear = now.getFullYear();

      var lastweekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek);
      var lastweekEndDate = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek));

      return [lastweekStartDate, lastweekEndDate];
    }

    // 모델별 깊은사고 활성화 여부 체크
    Vue.config.globalProperties.$checkUseThink = function (model) {
      if (!model) return 'disable';
      if (model.startsWith('gemma4:') || model.startsWith('gpt-oss:')) {
        return 'able';
      } else {
        return 'disable';
      }
    }
  }
}